// src/components/strumenti/StimaPotenzaClima.js
import React, { useState } from "react";
import { RefreshCw } from "lucide-react";
import { leggiNumero } from "../../utils/numeriStrumenti";

const inp = { padding:"10px 12px", border:"1px solid #e5e7eb", borderRadius:8, fontSize:14, fontFamily:"'Inter',sans-serif", outline:"none", width:"100%" };
const lbl = { fontSize:11, fontWeight:600, color:"#6b7280", display:"block", marginBottom:4 };

// Regola pratica indicativa: 100 W/m² per ambienti normali, con fattori correttivi di larga massima.
const FATTORI = { normale:100, molto_soleggiato:130, ultimo_piano:120, poco_isolato:140 };

export default function StimaPotenzaClima() {
  const [mq, setMq] = useState("");
  const [condizione, setCondizione] = useState("normale");

  const m = leggiNumero(mq)||0;
  const wattTotali = m * FATTORI[condizione];
  const btu = wattTotali * 3.412142;

  return (
    <div>
      <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12, marginBottom:16 }}>
        <div>
          <label style={lbl}>Superficie ambiente (m²)</label>
          <input value={mq} onChange={e=>setMq(e.target.value)} style={inp} placeholder="Es. 20"/>
        </div>
        <div>
          <label style={lbl}>Condizione ambiente</label>
          <select value={condizione} onChange={e=>setCondizione(e.target.value)} style={inp}>
            <option value="normale">Normale</option>
            <option value="molto_soleggiato">Molto soleggiato</option>
            <option value="ultimo_piano">Ultimo piano</option>
            <option value="poco_isolato">Poco isolato</option>
          </select>
        </div>
      </div>

      <div style={{ background:"#ecfeff", border:"1px solid #a5f3fc", borderRadius:10, padding:"14px 16px", textAlign:"center" }}>
        <div style={{ fontSize:11, color:"#9ca3af", fontWeight:600, marginBottom:4 }}>Potenza frigorifera indicativa</div>
        <div style={{ fontSize:22, fontWeight:800, color:"#0891b2" }}>
          {m>0 ? wattTotali.toLocaleString("it-IT",{maximumFractionDigits:0}) : "—"}
          <span style={{ fontSize:14, marginLeft:6, color:"#9ca3af" }}>W</span>
        </div>
        {m>0 && <div style={{ fontSize:12, color:"#6b7280", marginTop:4 }}>≈ {btu.toLocaleString("it-IT",{maximumFractionDigits:0})} BTU/h</div>}
      </div>
      <div style={{ fontSize:10, color:"#9ca3af", marginTop:8, textAlign:"center" }}>
        Stima di massima con regola pratica (100 W/m² circa) — non sostituisce un calcolo del carico termico.
      </div>

      <button onClick={()=>{setMq("");setCondizione("normale");}}
        style={{ marginTop:12, display:"flex", alignItems:"center", gap:6, fontSize:12, color:"#9ca3af", background:"none", border:"none", cursor:"pointer" }}>
        <RefreshCw size={12}/> Azzera
      </button>
    </div>
  );
}
